import * as React from "react";
import { inject } from "mobx-react";
import { observer } from "mobx-react";

// Components
import OptionsMenu, { MenuOption } from "components/common/OptionsMenu";
import CategoryItemCard, { CategoryItemCardProps } from "./CategoryItemCard";

interface OptionsCategoryItemCardProps extends CategoryItemCardProps {
    onMenuSelectionChangedCallback?: (option: MenuOption, key: string) => void;
}

@inject("rootStore")
@observer
export default class OptionsCategoryItemCard extends React.Component<OptionsCategoryItemCardProps> {
    render() {
        if (!this.props.rootStore) {
            return null;
        }
        let { onMenuSelectionChangedCallback, ...other } = this.props;
        return <CategoryItemCard {...other}>{this.renderIconMenu()}</CategoryItemCard>;
    }

    protected renderIconMenu = () => {
        let options: MenuOption[] = [MenuOption.Edit, MenuOption.Delete];
        return (
            <div style={{ right: 0, top: 0, position: "absolute" }}>
                <OptionsMenu options={options} onMenuSelectionChangedCallback={this.onMenuSelectionChanged} />
            </div>
        );
    };

    private onMenuSelectionChanged = (option: MenuOption) => {
        this.props.onMenuSelectionChangedCallback(option, this.props.item.key);
    };
}
